import React from 'react';

const UserMenu: React.FC = () => {
  return null;
};

export default UserMenu;
